export enum ArchiveReason{ 
    Discontinued = 'Discontinued',
    DuplicateItemEnteredError = "Duplicate Item/Entered in Error",
    TestItem = 'Test Item'
}